import { apiRequest } from './client';
import type {
  DashboardSummary,
  RecentActivityItem,
  RecentErrorItem,
  HealthStripItem,
} from '@/types';
import type { UUID } from '@/types';

export const dashboardApi = {
  /** Role-aware dashboard — platform / personal / tenant based on session. */
  getRoleDashboard(): Promise<DashboardSummary> {
    return apiRequest('/api/v1/dashboard');
  },

  getSummary(tenantId: UUID): Promise<DashboardSummary> {
    return apiRequest(`/api/v1/tenants/${tenantId}/dashboard/summary`, { tenantId });
  },

  getActivity(tenantId: UUID): Promise<RecentActivityItem[]> {
    return apiRequest(`/api/v1/tenants/${tenantId}/dashboard/activity`, { tenantId });
  },

  getErrors(tenantId: UUID): Promise<RecentErrorItem[]> {
    return apiRequest(`/api/v1/tenants/${tenantId}/dashboard/errors`, { tenantId });
  },

  getHealthStrip(tenantId: UUID): Promise<HealthStripItem[]> {
    return apiRequest(`/api/v1/tenants/${tenantId}/dashboard/health-strip`, { tenantId });
  },
};
